import React from "react";
import CartItem from "./CartItem";
import { useGlobalContext } from "../context";

const CartContainer = () => {
  const { cart, total, clearCart } = useGlobalContext();
  if (cart && cart.length === 0) {
    return (
      <section className="cart">
        {/* cart header */}
        <header>
          <h2>your bag</h2>
          <h4 className="empty-cart">is currently empty</h4>
        </header>
      </section>
    );
  }
  return (
    <section className="cart">
      {/* cart header */}
      <header>
        <h2 className="cart-title">your bag</h2>
      </header>
      {/* cart items */}
      <div>
        {cart &&
          cart.map((item) => {
            return <CartItem key={item.id} {...item} />;
          })}
      </div>
      {/* cart footer */}
      <footer>
        <hr />
        <div className="cart-total">
          <h4>
            total <span>${total}</span>
          </h4>
        </div>
        <button
          className="cart-btn cart-clear-btn"
          onClick={() => {
            clearCart();
          }}
        >
          clear cart
        </button>
      </footer>
    </section>
  );
};

export default CartContainer;
